import { name } from '../../package.json';

export const pkgName = name;
